
























import { defineComponent, ref, computed } from "@vue/composition-api";
import Menu from "@/components/navigation/Menu.vue";
import Overlay from "@/components/dashboard/Overlay.vue";
import Snackbar from "@/components/Snackbar.vue";

export default defineComponent({
  components: {
    Menu,
    Snackbar,
    Overlay,
  },
  setup(props, vm) {
    const menu = ref(null);
    const title = computed(() => vm.root.$route.meta.title);

    const breadcrumbs = () => {
      return vm.root.$route.matched
        .filter((i) => i.meta)
        .filter((i) => i.meta().breadcrumbs)
        .flatMap((i) => (i.meta ? i.meta().breadcrumbs(vm.root.$route) : null));
    };

    return {
      breadcrumbs,
      menu,
      title,
    };
  },
});
